// extracted by mini-css-extract-plugin
export var actionButton = "_90-1";
export var actionButtons = "_90-2";
export var actions = "_90-0";
export var aiUnread = "_90-10";
export var alignCenter = "_90-h";
export var backWrapper = "_90-3";
export var cellContainer = "_90-4";
export var checkboxContainer = "_90-5";
export var contentContainer = "_90-6";
export var contentHeader = "_90-8";
export var conversationsTableWrapper = "_90-s";
export var draftReplyBadgeContainer = "_90-m";
export var dropdownItem = "_90-b";
export var dropdownItemsContainer = "_90-a";
export var dropdownTitle = "_90-c";
export var errorIcon = "_90-7";
export var filter = "_90-d";
export var gray = "_90-i";
export var headerActionButtons = "_90-e";
export var headerCheckboxContainer = "_90-f";
export var icon = "_90-j";
export var menuContainer = "_90-k";
export var noMoreTicketsIcon = "_90-12";
export var noMoreTicketsSubText = "_90-13";
export var oneLine = "_90-l";
export var optionsButton = "_90-n";
export var plus = "_90-o";
export var portalButtonsWrapper = "_90-g";
export var red = "_90-p";
export var scrolledTop = "_90-9";
export var search = "_90-q";
export var selectedConversationsCount = "_90-r";
export var spinner = "_90-t";
export var strong = "_90-u";
export var summaryCell = "_90-v";
export var tableContainer = "_90-11";
export var tagContainer = "_90-w";
export var threeDots = "_90-x";
export var twoLines = "_90-y";
export var unread = "_90-z";